/* =============================================================================
   Greatest Collections — Custom Element
   
   Sticky content behavior is handled entirely by CSS (position: sticky).
   This custom element only handles the reveal-on-scroll animation trigger.
   ============================================================================= */

(function () {
  'use strict';

  class GreatestCollectionsSticky extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('reveal-on-scroll')) {
        this._setupReveal();
      }
    }

    _setupReveal() {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this);
    }
  }

  if (typeof window.customElements !== 'undefined') {
    window.customElements.define('greatest-collections-sticky', GreatestCollectionsSticky);
  }
})();
